import { useDispatch } from 'react-redux';
import { Drawer, DrawerContent } from "../../ui/drawer";
import styles from './A23TournamentEliminationDrawer.module.css';
import { 
  useOpenTourneyEliminationModal,
  useTourneyGameCompleted
} from '@/src/hooks/data/useGameTable';
import useGameSocket from '@/src/hooks/utils/useGameSocket';
import { deleteGameTable } from '@/Poker/redux/slices/gameTableSlice';
import { useNavigate } from 'react-router';
import useActiveGames from '@/src/hooks/data/useActiveGames';

function A23TournamentEliminationDrawer({ tempTableId }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const activeGames = useActiveGames();
    const openTourneyEliminationModal = useOpenTourneyEliminationModal(tempTableId);
    const tourneyGameCompleted = useTourneyGameCompleted(tempTableId);
    const { triggerExitTableFlow } = useGameSocket(tempTableId);

    const handleOutsideClick = () => {
        // Handle outside click if needed
    }

    const goToLobby = () => {
        if (!tourneyGameCompleted) {
            return triggerExitTableFlow();
        }
        if (activeGames.length === 1) {
            navigate(-1, { replace: true });
        }
        dispatch(deleteGameTable({ tempTableId }));
    }

    if (!openTourneyEliminationModal) {
        return null;
    }

    return (
        <Drawer dismissible={false} open={openTourneyEliminationModal}>
            <DrawerContent draggable={false} showCloseButton={false} onInteractOutside={handleOutsideClick} side="bottom" className={styles.container}>
                {/* Header with centered title and close button */}
                <div className={styles.header}>
                    <div className={styles.headerSpacer}></div>
                    <h2 className={styles.title}>Thanks for playing!</h2>
                </div>

                <div className={styles.content}>
                    <div className={styles.messageContainer}>
                        <p className={styles.messageText}>
                            Poker can be a tough grind at times. Keep pushing, the big win is just around the corner.
                        </p>
                    </div>

                    <button
                        className={styles.actionButton}
                        onClick={goToLobby}
                    >
                        Go To Lobby
                    </button>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

export default A23TournamentEliminationDrawer; 